import { forwardRef } from "react";
import Avatar from "./Avatar";
import Bubble from "./Bubble";
import TypingDots from "./TypingDots";

// Scrollable message region — day chips + bubbles + typing indicator.
// Tap anywhere here to dismiss the keyboard.
const MessageList = forwardRef(function MessageList(
  { loading, messages, rendered, title, myId, otherProfile, otherTyping,
    otherSeenMsgId, otherSeenAt, onTapDismiss },
  ref,
) {
  return (
    <main
      ref={ref}
      className="flex-1 overflow-y-auto px-3 min-h-0 space-y-2"
      onClick={onTapDismiss}
      style={{
        WebkitOverflowScrolling: "touch",
        overscrollBehavior: "contain",
        backgroundColor: "#FAFAF8",
        backgroundImage: "url('https://customer-assets.emergentagent.com/job_case-counsel-iraq/artifacts/tem1y4ib_IMG_4626.jpeg')",
        backgroundRepeat: "repeat",
        backgroundSize: "320px auto",
        paddingBottom: "calc(60px + env(safe-area-inset-bottom))",
      }}
    >
      {loading && (
        <div className="h-full flex items-center justify-center text-[#8A8A8A] text-sm">
          جارٍ تَحميل المحادثة…
        </div>
      )}

      {!loading && messages.length === 0 && (
        <div className="h-full flex flex-col items-center justify-center text-center px-8">
          <div className="mb-4"><Avatar name={title} size={72} avatarId={otherProfile?.avatar_id || ""} /></div>
          <div className="text-[#0A192F] font-bold text-[16px]">ابدأ المحادثة مع {title}</div>
          <div className="text-[#5A6470] text-[13px] mt-2 leading-relaxed max-w-xs">
            الرسائل مَحفوظة بِسرّية تامة على خوادم LexIQ.<br/>اكتب أدناه لِبَدء التواصل.
          </div>
        </div>
      )}

      {rendered.map((item) => {
        if (item.kind === "day") {
          return (
            <div key={item.id} className="flex justify-center my-3">
              <span className="text-[11px] px-3 py-1 rounded-full bg-[#F4F4F2] text-[#5A6470] border border-[#EAEAEA]">
                {item.label}
              </span>
            </div>
          );
        }
        const m = item.msg;
        const mine = m.sender_id === myId;
        const seen = mine && (
          m.id === otherSeenMsgId
          || (otherSeenAt && (m.created_at || "") <= otherSeenAt)
        );
        return (
          <Bubble
            key={item.id}
            msg={m}
            mine={mine}
            showTime={item.isLastOfGroup}
            seen={seen}
            showAvatar={!mine && item.showAvatar}
            sender={otherProfile}
          />
        );
      })}

      {otherTyping && (
        <div className="flex justify-start items-end gap-2">
          <Avatar name={otherProfile?.name} size={28} avatarId={otherProfile?.avatar_id || ""} />
          <TypingDots />
        </div>
      )}
    </main>
  );
});

export default MessageList;
